import React, { lazy } from 'react';
import projectJournalRoutes from './ProjectJournal/ProjectJournalRoutes';

const ProjectAccountingSubmenu = lazy(() =>
  import('./ProjectAccountingSubmenu').then(module => ({
    default: module.ProjectAccountingSubmenu,
  })),
);

const projectAccountingRoutes = [
  ...projectJournalRoutes,
  {
    props: { exact: true, path: '/project-accounting' },
    component: <ProjectAccountingSubmenu />,
  },
];

export default projectAccountingRoutes;
